import axios from 'axios';

const api = axios.create({
  baseURL: 'https://rgform-prod.leapeasyapi.com/api',
  // baseURL: 'http://localhost:4000/api'
});

export const getProperty = async (data) => {
  const response = await api.get('/property?state=' + data);
  return response.data;
};

export const submitFormData = async (data) => {
  const response = await api.post('/create', data);
  return response.data;
};

export const stripeCall = async (data) => {
  const response = await api.post('/create-payment', data);
  return response.data;
};

export const getCoverageAmount = async (data) => {
  const response = await api.get('/coverageAmount?propertyId=' + data);
  return response.data;
};

export const sendEmailVerificationCode = async (data) => {
  const response = await api.post('/send-email-verification', data);
  return response.data;
};

export const verifyEmail = async (data) => {
  const response = await api.post('/verify-email', data);
  return response.data;
};
